module.exports = __webpack_public_path__ + "img/luck_pak_txt.24dde0a5.png";